import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Nav from '../../components/Nav/Nav'
import smallRatedPeople from '../assets/smallRatedPeople.png'
import instagram from '../../components/Review/assets/instagram.svg'
import fullStar from '../../components/Review/assets/fullStar.svg'
import emptyStar from '../../components/Review/assets/emptyStar.svg'
import Footer from '../../components/Footer/Footer'
import CreateAccountModal from '../../components/CreateAccountModal/CreateAccountModal'
import Review from '../../components/Review/Review'
import DashboardNav from '../../components/Nav/DashboardNav'
import { jwtDecode } from 'jwt-decode'
import CountrySelector from '../Home/CountrySelector';
import CategorySelector from '../Home/CategorySelector';
import VendorSelector from '../Home/VendorSelector';
import search_icon from '../assets/search.svg';
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';
import bookmark from '../assets/bookmark.svg';
import bookmarkFilled from '../assets/bookmark_fill.svg';
import Whatsappimage from '../assets/whatsapp.svg'
import locationicon from '../assets/locationicon.svg'
import axios from 'axios';
import baseUrl from '../../components/baseUrl';


const Vendor = ({ savedVendorData, setSavedVendorData, toggleSaveVendor }) => {
    const location = useLocation();
    const { user, vendor, filteredVendorData = [] } = location.state || {};
    const navigate = useNavigate();
    const [accessToken, setAccessToken] = useState()

    const [createAccount, setCreateAccount] = useState(null)
    //const [user, setUser] = useState(null)
    const [averageRating, setAverageRating] = useState(null);
    // const [latestServiceEstimate, setLatestServiceEstimate] = useState(null);
    const [hireAgainTotal, sethireAgainTotal] = useState(null);
    const [recommendAgainTotal, setrecommendAgainTotal] = useState(null);

    // Function to calculate the average rating and round to nearest integer
    const calculateAverageRating = (ratings) => {
        if (ratings.length === 0) return 0; // Handle no ratings

        // Sum all the rating scores
        const totalRating = ratings.reduce((acc, rating) => acc + rating.rating_score, 0);

        // Calculate the average
        const average = totalRating / ratings.length;

        // Round to the nearest integer (1 to 5 scale)
        return Math.round(average); // This will round the average to the nearest whole number
    };


    // Function to get the latest service_estimate that is not null
    const getLatestServiceEstimate = (ratings) => {
        if (ratings.length === 0) return null; // No ratings, return null

        // Sort the ratings by createdAt (or rating_date) in descending order
        const sortedRatings = ratings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        // Find the first rating with a non-null service_estimate
        for (let i = 0; i < sortedRatings.length; i++) {
            if (sortedRatings[i].service_estimate !== null) {
                return sortedRatings[i].service_estimate;
            }
        }

        // If no service_estimate is found, return null
        return null;
    };

    const calculateHireAndRecommendTotals = () => {
        if (!filteredVendorData || filteredVendorData.length === 0) return;

        let hireAgainTrue = 0;
        let hireAgainFalse = 0;
        let recommendAgainTrue = 0;
        let recommendAgainFalse = 0;

        filteredVendorData.forEach((review) => {
            if (review.hire_again) {
                hireAgainTrue++;
            } else {
                hireAgainFalse++;
            }

            if (review.recommend_again) {
                recommendAgainTrue++;
            } else {
                recommendAgainFalse++;
            }
        });

        sethireAgainTotal({ true: hireAgainTrue, false: hireAgainFalse });
        setrecommendAgainTotal({ true: recommendAgainTrue, false: recommendAgainFalse });
    };


    const calculateVendorEstimate = (reviews) => {
        if (!reviews || reviews.length === 0) return null;

        // Filter reviews with service_estimate
        const reviewsWithEstimates = reviews.filter(review => review.rating?.service_estimate !== null);

        if (reviewsWithEstimates.length === 0) return null;

        // Find the most recent event date
        const latestEventDate = reviewsWithEstimates.reduce((latest, review) => {
            const eventDate = new Date(review.event_date);
            return eventDate > latest ? eventDate : latest;
        }, new Date(0));

        // Group estimates by currency
        const estimateByCurrency = {};

        reviewsWithEstimates.forEach(review => {
            const currency = review.rating.service_estimate_currency || "Unknown Currency";
            const amount = review.rating.service_estimate || 0;

            if (!estimateByCurrency[currency]) {
                estimateByCurrency[currency] = { total: 0, count: 0 };
            }

            estimateByCurrency[currency].total += amount;
            estimateByCurrency[currency].count += 1;
        });

        // Compute the average estimate per currency
        const finalEstimates = {};
        Object.keys(estimateByCurrency).forEach(currency => {
            finalEstimates[currency] = estimateByCurrency[currency].total / estimateByCurrency[currency].count;
        });

        return { estimateByCurrency: finalEstimates, latestEventDate };
    };


    const vendorEstimate = calculateVendorEstimate(filteredVendorData);
    const latestServiceEstimate = vendorEstimate ? vendorEstimate.estimateByCurrency : null;
    const latestEventDate = vendorEstimate ? new Date(vendorEstimate.latestEventDate).toLocaleString('en-US', { year: 'numeric', month: 'long' }) : null;

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }
    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        if (storeToken) {
            try {
                const decodedToken = decodeData(storeToken); // Ensure decodeData is correct
                setAccessToken(decodedToken); // Set the token in state
            } catch (error) {
                console.error("Error decoding token:", error);
                setAccessToken(null); // Set it explicitly to avoid undefined
            }
        } else {
            setAccessToken(null);
        }
    }, []);


    useEffect(() => {
        if (!vendor) {
            navigate('/');
            return; // Exit the function early to prevent further execution
        }

        // Calculate and set the average rating when vendorData changes
        if (vendor.ratings) {
            const avg = calculateAverageRating(vendor.ratings);
            setAverageRating(avg);
        }
    }, [navigate, vendor]);


    useEffect(() => {
        if (filteredVendorData) {
            calculateHireAndRecommendTotals();
        }
    }, [filteredVendorData]);

    const serviceType = vendor?.category
        ? `${vendor.category?.category_name} services`
        : "services";

    const isSaved = savedVendorData.some(
        v => v.vendor_id === vendor.vendor_id
    );

    return (
        <div className='min-h-screen flex flex-col justify-between '>
            {
                user ?
                    <DashboardNav />
                    :
                    <Nav />
            }
            {
                createAccount ? <CreateAccountModal setCreateAccount={setCreateAccount} /> : null
            }

            <div>
                <div className=' pt-[121px] md:pt-[152px] lg:pt-[160px] xl:pt-[180px] pb-[102px]  w-full flex flex-col gap-[50px] bg-custom-gradient'>
                    <div className='  w-full flex flex-col  md:flex-row gap-[30px] justify-between items-start text-center md:text-start'>
                        <div className='w-full px-[24px]  md:px-[32px] xl:px-[64px] flex flex-col gap-2  text-white md:mt-[12px] lg:mt-[0]'>
                            {/**Name, Stars and More*/}
                            <div className='  w-full flex flex-col gap-2 md:justify-between'>
                                <div className='flex flex-col md:flex-row md:gap-[10px] lg:gap-[16px] text-left items-start md:items-normal md:justify-between'>

                                    {/* Large Screen Search */}

                                    <div className=' flex flex-col gap-[6px] md:gap-0 '>
                                        <h1 className=' font-bold text-[25px]  leading-[33.75px] lg:text-[36px] lg:leading-[54px] xl:text-[50px]  xl:leading-[67.5px]  text-white '> {vendor?.vendor_name} </h1>
                                        <div className='flex flex-col md:flex-row '>

                                            {/* Star, Rating, Category, and Country */}
                                            <div className='flex items-center gap-2 mt-[6px] flex-wrap md:flex-nowrap'>

                                                {/* Star + Rating */}
                                                {filteredVendorData?.length > 0 && (
                                                    <div className='flex items-center gap-1'>
                                                        <img
                                                            src={fullStar}
                                                            alt="star"
                                                            className='w-[20px] h-[20px]'
                                                        />
                                                        <span className='text-white font-medium text-sm'>
                                                            {averageRating !== null ? averageRating.toFixed(1) : "0.0"}
                                                        </span>
                                                    </div>
                                                )}

                                                {/* Category Name */}
                                                <p className='text-white font-medium text-nowrap text-sm'>
                                                    {vendor?.category?.category_name} ({filteredVendorData?.length || 0} Reviews)
                                                </p>
                                                {/* Number of reviews */}


                                                {/* Country Box */}
                                                <div className='flex items-center gap-[4px] border bg-white h-6 rounded-[80px] px-2 py-[3px] justify-center'>
                                                    {/* Location Icon */}
                                                    <img src={locationicon} alt="location" className='w-[14px] h-[16px]' />
                                                    <p className='text-[#0079FF] text-[12px] font-bold'>
                                                        {vendor?.city ? `${vendor.city}, ` : ""}
                                                        {vendor?.vendor_country?.vendor_country_name}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Social buttons */}
                                    <div className="mt-[27px] gap-[6px] flex flex-row md:flex-col md:items-end gap-2  lg:flex-row">
                                        {/* Instagram button */}
                                        {vendor?.vendor_address && (
                                            <a
                                                href={vendor.vendor_address}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-[140px] h-[52px] md:w-[130px] md:h-[42px] lg:w-[140px] lg:h-[52px] inline-flex items-center justify-center gap-[3px] border-[2px] border-white rounded-[80px] transition duration-300 group"
                                            >
                                                <span className="text-white font-bold text-[14px] transition duration-300">
                                                    Visit Page
                                                </span>
                                                <img
                                                    src={instagram}
                                                    alt="instagram"
                                                    className="size-[32px] transition duration-300"
                                                />
                                            </a>
                                        )}

                                        {/* WhatsApp button */}
                                        <a
                                            href={
                                                vendor?.whatsappNumber
                                                    ? `https://wa.me/${vendor.whatsappNumber}?text=${encodeURIComponent(
                                                        `Hi ${vendor?.vendor_name}, my name is ${user?.first_name}. I'm interested in your ${serviceType} for my upcoming event and would love more details.`)}`

                                                    : undefined
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => {
                                                if (!vendor?.whatsappNumber) {
                                                    e.preventDefault(); // stop navigation
                                                }
                                            }}
                                            className={`w-[180px] h-[52px] md:w-[172px] md:h-[42px] lg:w-[180px] lg:h-[52px] 
    inline-flex items-center justify-center gap-[3px] border-[2px] border-white 
    rounded-[80px] transition duration-300 group
    ${!vendor?.whatsappNumber ? "opacity-50 cursor-not-allowed" : ""}`}
                                        >
                                            <span className="text-white font-bold text-[14px]">Message Vendor</span>
                                            <img src={Whatsappimage} alt="whatsapp" className="size-[32px]" />
                                        </a>
                                    </div>


                                </div>

                                {vendor.serviceDescription && (

                                    <div className='mt-[32px] text-sm font-bold text-start space-y-[10px] md:w-3/5 lg:w-4/5 xl:w-3/5'>
                                        <p>About vendor</p>
                                        <p>{vendor.serviceDescription}</p>
                                    </div>
                                )}

                                {/**More */}
                                {filteredVendorData?.length > 0 && (
                                    <div className='lg:left-[73px] h-auto mt-10  flex flex-row  w-fit  px-[24px]  py-[18px] md:py-6 gap-2.5 sm:gap-[16px] lg:gap-[15px] lg:gap-[31px]  justify-between bg-white rounded-[20px] '>
                                        {/**Hire */}
                                        <div className='flex flex-col items-center '>
                                            <h1 className=' flex gap-[10px] items-center  font-black text-[#FEAD00] text-nowrap text-lg md:text-xl xl:text-xxl'> {hireAgainTotal?.true} out of {filteredVendorData.length} </h1>
                                            <p className=' font-bold text-ravash text-[12px] leading-[16.2px] xl:text-base text-start'>Hire again</p>
                                        </div>
                                        <div className='w-auto border-t-none border-l border-tcfgray mt-[7px]' />
                                        {/**Recommend */}
                                        <div className='flex flex-col mb-[15px] items-center'>
                                            <h1 className=' flex gap-[10px] items-center  font-black text-[#FEAD00] text-nowrap text-lg md:text-xl'> {recommendAgainTotal?.true} out of {filteredVendorData.length}</h1>
                                            <p className=' font-bold text-ravash text-[12px] leading-[16.2px] xl:text-base text-start'> Recommend </p>
                                        </div>
                                        <div className='w-auto border-t-none border-l border-tcfgray mt-[7px]' />
                                        {/* Estimate */}
                                        {/* <div className='flex flex-col mb-[15px]'>
                                            <h1 className=' flex gap-[10px] items-center font-black text-[#FEAD00] text-nowrap text-[18px] leading-[33.75px]'>GHc {latestServiceEstimate}</h1>
                                            <p className=' font-bold text-ravash text-[12px] leading-[16.2px] xl:text-base text-start'>Average cost per service </p>
                                        </div>     */}
                                        {/* <div className={` ${latestServiceEstimate === null ? "" : " border-t md:border-l"} w-full  md:w-auto md:border-t-none  mt-[7px] md:mt-0`} /> */}

                                        {/**Estimate */}
                                        <div className="flex flex-col items-center">
                                            <h1 className="flex gap-[10px] font-black text-[#FEAD00] text-nowrap text-lg items-start md:text-xl">
                                                GH₵ {latestServiceEstimate ? Number(latestServiceEstimate.GHS).toFixed(1) : "0.0"}
                                            </h1>
                                            <p className="font-bold text-ravash text-[12px] leading-[16.2px] xl:text-base text-center">
                                                {latestServiceEstimate ? 'Average cost per service' : "No cost estimate available yet"}
                                            </p>
                                        </div>

                                    </div>
                                )}
                                <div className='flex flex-col md:flex-row gap-3 mt-[25px] w-full justify-center'>
                                    {/* Write a Review Button */}
                                    <button
                                        onClick={() => navigate('/rate', { state: { user, vendor } })} className='w-full h-[44px] bg-[#0079FF] text-white text-[18px] font-bold rounded-[80px] transition hover:bg-[#005FCC]'> Write a review </button>

                                    {/* Save Vendor Button */}
                                    {/* <button onClick={() => console.log("Save Vendor clicked")} className='w-full  h-[44px] border-[white] text-[18px] text-[white] border-[2px] font-bold rounded-[80px] transition flex items-center justify-center gap-2.5'> <img src={bookmark} alt="bookmark" className='w-[24px] h-[24px]' /> Save vendor </button> */}
                                    <button
                                        onClick={() => toggleSaveVendor(vendor)}
                                        className={`w-full h-[44px] border-[2px] text-[18px] font-bold rounded-[80px] transition 
    flex items-center justify-center gap-2.5
    ${isSaved
                                                ? 'bg-white text-black border-white'
                                                : 'text-white border-white'
                                            }
  `}
                                    >
                                        <img
                                            src={isSaved ? bookmarkFilled : bookmark}
                                            alt="bookmark"
                                            className={`${isSaved?"w-[20px] h-[20px]":"w-[24px] h-[24px]"}`}
                                        />
                                        {isSaved ? 'Saved' : 'Save vendor'}
                                    </button>

                                </div>


                            </div>
                        </div>

                        {/* <img src={smallRatedPeople} alt="smallRatedPeople" className=' hidden md:flex md:w-[300px] lg:w-[351px] xl:w-[451px] xl:h-[204px]' /> */}
                    </div>
                </div>
                <div className={` w-full -mt-[55px] rounded-t-[50px] md:rounded-t-[40px] lg:rounded-t-[50px]  ${filteredVendorData.length > 0 ? 'pt-[37px] ' : 'pt-[70px]'} md:pt-[32px] px-[24px] md:px-[32px] xl:px-[64px] bg-white`}>




                    {filteredVendorData && filteredVendorData.length > 0 ? (
                        // Sort and slice the data to get the 5 most recent reviews
                        <>
                            <p className='text-lg font-bold'>Reviews</p>
                            {/* <div className='grid grid-cols-[repeat(auto-fit,_minmax(327px,_1fr))] sm:grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))]  lg:grid-cols-[repeat(auto-fit,_minmax(310px,310px))] xl:grid-cols-[repeat(auto-fit,_minmax(380px,427px))] mt-[24px] md:mt-[27px] mx-auto w-full flex flex-wrap gap-[13px] md:gap-[19px] lg:gap-[27px] xl:gap-x-4 md:gap-y-[52px]'> */}
                            <div className='grid grid-cols-[repeat(auto-fill,_minmax(327px,_1fr))] sm:grid grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))]  lg:grid-cols-[repeat(auto-fill,_minmax(310px,_1fr))] xl:grid-cols-[repeat(auto-fill,_minmax(426px,_1fr))] mt-[29px] md:mt-[26px] lg:mt-[23px] w-full flex flex-wrap gap-[30px] sm:gap-4 md:gap-[22px] lg:gap-x-[15px] xl:gap-x-[16px] gap-y-[30px] md:gap-y-[40px] lg:gap-y-[36px] xl:gap-y-[60px]'>


                                {filteredVendorData
                                    .sort((a, b) => new Date(b.feedback_date) - new Date(a.feedback_date)) // Sort by date in descending order
                                    .map((item, index) => (
                                        <Review key={index} accessToken={accessToken} user={user} item={item} setCreateAccount={setCreateAccount} page='vendor' />
                                    ))}
                            </div>
                        </>

                    ) :
                        (<div className=' w-full   pb-[100px] bg-white flex flex-col items-center justify-center '>
                            <h1 className=' font-black text-lg lg:text-[25px] lg:leading-[33.75px] xl:text-[30px] xl:leading-[40.5px]'>Rate this vendor</h1>
                            {
                                user ?
                                    <p className='mt-[10px] w-full items-center justify-center text-center font-medium text-ravash text-sm mr-1'>Sorry, this vendor has not been rated yet. <span> Be the first to leave a review</span></p>
                                    :
                                    <>
                                        <p className='mt-[10px] w-full  text-center font-medium text-ravash text-sm '>Sorry, this vendor has not been rated yet. <span> Login to be the first to rate this vendor</span></p>

                                    </>
                            }
                            <button onClick={() => navigate('/login')} className={` ${user ? "hidden" : "flex"} mt-[30px] w-[200px] h-[50px] rounded-[80px] bg-[#0079FF]  items-center justify-center text-center font-bold text-white text-sm`}>Login</button>
                        </div>

                        )}


                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Vendor
